// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/lib/es6/src/Jzon.res.js";
import * as V2f$Linear from "lumi-linear/lib/es6/src/V2f.res.js";
import * as Transform$Linear from "lumi-linear/lib/es6/src/Transform.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as AxesModel$LumiDocuments from "./AxesModel.res.js";
import * as StaplePlaceCount$LumiDocuments from "./StaplePlaceCount.res.js";

import '../../../src/css/place-model.scss'
;

let jsonCodec = Jzon.object3(param => [
  param.axes,
  param.flipSide,
  param.staplePlaceCount
], param => ({
  TAG: "Ok",
  _0: {
    axes: param[0],
    flipSide: param[1],
    staplePlaceCount: param[2]
  }
}), Jzon.field("axes", AxesModel$LumiDocuments.jsonCodec), Jzon.field("flipSide", Jzon.bool), Jzon.field("staplePlaceCount", StaplePlaceCount$LumiDocuments.jsonCodec));

function transform(placeModelSpaceSize, hmirror, vflip, sm) {
  return {
    axes: AxesModel$LumiDocuments.transform(placeModelSpaceSize, hmirror, vflip, sm.axes),
    flipSide: sm.flipSide,
    staplePlaceCount: sm.staplePlaceCount
  };
}

function warpAffine(sm, m23) {
  return {
    axes: AxesModel$LumiDocuments.warpAffine(sm.axes, m23),
    flipSide: sm.flipSide,
    staplePlaceCount: sm.staplePlaceCount
  };
}

function toAxesModel(sm) {
  let displacementDirection = sm.flipSide ? -1 : 1;
  let match = sm.staplePlaceCount;
  let relativeDisplacement;
  relativeDisplacement = match === "OnePlace" ? 1 / 2 : 1 / 4;
  let sideRel = V2f$Linear.minus(sm.axes.side, sm.axes.baseFront);
  let displacement = V2f$Linear.scale(sideRel, relativeDisplacement * displacementDirection);
  let m23 = Transform$Linear.M23f.translation(displacement);
  return AxesModel$LumiDocuments.warpAffine(AxesModel$LumiDocuments.elongateBase(sm.axes, 1.3), m23);
}

function toPoly(sm, placeClass) {
  return AxesModel$LumiDocuments.toPoly(toAxesModel(sm), placeClass);
}

function extraPoints(sm) {
  return AxesModel$LumiDocuments.extraPoints(sm.axes).concat(AxesModel$LumiDocuments.extraPoints(toAxesModel(sm)));
}

function mainPoint(sm) {
  return AxesModel$LumiDocuments.mainPoint(toAxesModel(sm));
}

function StapleModel$Svg(props) {
  let __upClassList = props.upClassList;
  let __sideClassList = props.sideClassList;
  let __baseClassList = props.baseClassList;
  let stapleModel = props.stapleModel;
  let baseClassList = __baseClassList !== undefined ? __baseClassList : [];
  let sideClassList = __sideClassList !== undefined ? __sideClassList : [];
  let upClassList = __upClassList !== undefined ? __upClassList : [];
  let displacedAxes = toAxesModel(stapleModel);
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx(AxesModel$LumiDocuments.Svg.make, {
        axesModel: stapleModel.axes,
        baseClassList: baseClassList,
        sideClassList: sideClassList,
        upClassList: upClassList
      }),
      JsxRuntime.jsx(AxesModel$LumiDocuments.Svg.Base.make, {
        baseFront: displacedAxes.baseFront,
        baseBack: displacedAxes.baseBack,
        classList: baseClassList.concat([[
            "place-model-projection",
            true
          ]])
      })
    ]
  });
}

let Svg = {
  make: StapleModel$Svg
};

export {
  jsonCodec,
  transform,
  warpAffine,
  toAxesModel,
  toPoly,
  extraPoints,
  mainPoint,
  Svg,
}
/*  Not a pure module */
